<div class="p-d-flex p-flex-column p-center photo-block" [class.rounded]="rounded"
     [ngClass]="{'main-image': isMainPhoto}">
  <img class="image" src="assets/images/1x_no_image_and_video.png" alt="no-photo" loading="lazy">
</div>
